import { render, staticRenderFns } from "./quicknew.vue?vue&type=template&id=13a96754&scoped=true&"
import script from "./quicknew.vue?vue&type=script&lang=js&"
export * from "./quicknew.vue?vue&type=script&lang=js&"
import style0 from "./quicknew.vue?vue&type=style&index=0&id=13a96754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a96754",
  null
  
)

export default component.exports